
import * as FaIcons from 'react-icons/fa';
import React, { Fragment, useState, useEffect } from 'react'
import { GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow } from 'react-google-maps'
import { Link } from 'react-router-dom';
import * as AiIcons from 'react-icons/ai';
import * as FcIcons from 'react-icons/fc';
import { useForm } from 'react-hook-form';
import { Modal, Button } from "react-bootstrap";
import AxiosService from "../services/axios.service";
import AuthService from "../services/auth.service";
const API_PATH = "agencies";

function List(match) {
  const { path } = match;
  const [mod, setMod] = useState(false);
  const [admin, setAdmin] = useState(false);
  const [agencies, setAgencies] = useState(null);
  const [results, setResults] = useState(0);
  const [deleteId, setDeleteId] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    console.log("close");
  };

  const confirmDelete = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  function deleteAgency() {
    console.log("deleting agency id: " + deleteId);
    setAgencies(agencies.map(x => {
      if (x.id === deleteId) { x.isDeleting = true; }
      return x;
    }));
    AxiosService.delete(API_PATH, deleteId).then(() => {
      setAgencies(agencies => agencies.filter(x => x.id !== deleteId));
    });
    setShow(false);
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    if (user) {
      setMod(user.roles.includes("ROLE_MODERATOR"));
      setAdmin(user.roles.includes("ROLE_ADMIN"));
    }
    AxiosService.getAll(API_PATH).then(x => setAgencies(x.data) & setResults(x.data.length));
  }, []);

  const { register, watch, formState: { errors }, handleSubmit } = useForm();

  function search() {
    var keyword = watch("query").toLowerCase();
    console.log("keyword: " + keyword);
    AxiosService.getAll(API_PATH).then(x => {
      console.log(JSON.stringify(x.data));
      var queries = x.data.filter(item => item.name.toLowerCase().includes(keyword))
      setAgencies(queries)
      setResults(queries.length)
    }
    );
  }

  function deleteAgency() {
    console.log("deleting agency id: " + deleteId);
    setAgencies(agencies.map(x => {
      if (x.id === deleteId) { x.isDeleting = true; }
      return x;
    }));
    AxiosService.delete(API_PATH, deleteId).then(() => {
      setAgencies(agencies => agencies.filter(x => x.id !== deleteId));
    });
    setShow(false);
  };

  return (
    <Fragment >
      {/* <GoogleMap
          defaultZoom={6}
          defaultCenter={{ lat: 38.907192, lng: -77.036873 }}
        >
          {agencies && agencies.map(agency =>
            <Marker
              key={agency.id}
              id={agency.id}
              position={{
                lat: agency.latitude,
                lng: agency.longitude
              }}
              onClick={() =>
                setSelectedAge(agency)
  
  
              }
            // icon={{
            //   url: './gavel.png',
            //   scaledSize: new window.google.maps.Size(25, 25)
            // }}
            />
          )}
          {selectedAge &&
            <InfoWindow position={{
              lat: selectedAge.latitude,
              lng: selectedAge.longitude
            }}
  
              onCloseClick={() => {
                setSelectedAge(null);
              }}
  
  
            >
  
  
              <div className="pickle">
                <h2 style={{ fontWeight: 'bold' }}>{selectedAge.name}</h2>
                <p>{selectedAge.email}</p>
                <p>{selectedAge.phone}</p>
                <Link to={`/agencys/view/${selectedAge.id}`} className="btn btn-sm btn-info"> <VscIcons.VscOpenPreview size={12} /> View agency </Link>
  
              </div>
            </InfoWindow>
          }
  
        </GoogleMap> */}

      <h1 style={{ textAlign: 'center' }}>Agencies</h1>
      {(mod || admin) && (
        <Link to={`/agencies/add`} style={{ marginTop: 10 }} className="btn btn-sm btn-success mb-2">Add Agency</Link>
      )}
      <form onSubmit={handleSubmit(search)} onReset={useEffect}>
        <div className="form-row">
          <div className="form-group col-5">
            <input name="query" type="text" ref={register} {...register("query", {})} className={`form-control ${errors.query ? 'is-invalid' : ''}`} />
            <div className="invalid-feedback">{errors.query?.message}</div>
          </div>
          <div className="form-group col-5">
            {/*<button onClick={search} style={{ marginRight: 8 }} class="btn btn-light" id="search">Search <FcIcons.FcSearch size={24} /></button>*/}
            <button class="btn btn-light" type="submit">Search <FcIcons.FcSearch size={24} /></button>
          </div>
        </div>
      </form>
      <text>Results: {results}</text>
      <div className='pickle' style={{ zIndex: -1 }}>

        <table className="table-munch table table-bordered table-responsive table-hover table-hover-cursor">
          <thead style={{ marginTop: 15 }}>
            <tr >

              <th style={{ width: '50%' }}>Agency Name</th>
              <th style={{ width: '50%' }}>Description</th>

            </tr>
          </thead>
          <tbody class="searchable">
            {agencies && agencies.map(agency =>
              <tr key={agency.id}>
                <td>{agency.name}</td>
                <td>{agency.description}</td>

                <td style={{ whiteSpace: 'nowrap' }}>


                  {/* <Link to={`/agencies/view/${agency.id}`} className="btn btn-sm btn-info mr-2"> <VscIcons.VscOpenPreview size={22} /> </Link> */}
                  {(mod || admin) && (
                    <Link to={`/agencies/edit/${agency.id}`} className="btn btn-sm btn-primary mr-2"> <AiIcons.AiTwotoneEdit size={22} /> </Link>
                  )}
                  {admin && (
                    <button
                      className="btn btn-sm btn-danger mr-2"
                      onClick={() => confirmDelete(agency.id)}
                    >
                      <FaIcons.FaUserMinus size={22} />
                    </button>
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Delete?</Modal.Title>
          </Modal.Header>
          <Modal.Body>Would you like to delete this Agency?</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => deleteAgency(agencies.id)}>
              OK
            </Button>
            <Button variant="primary" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </Fragment>
  );
}
const WrappedMap = withScriptjs(withGoogleMap(List));

export default function agentMap() {
  return (
    <div style={{ width: '70vw', height: '60vh', position: 'absolute', left: 270, zIndex: 1001 }}>
      <WrappedMap googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyA8oEXVIh8RoYuGQO-J0-iMEAL0wQGYSU8`}
        loadingElement={<div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: "100%" }} />}
      />

    </div>
  )
}

export { List };
//         <div>
//             <h1>Agencies</h1>
//             <Link to={`${path}/add`} className="btn btn-sm btn-success mb-2"> Add Agency </Link>
//             <table className="table table-bordered">
//                 <thead>
//                     <tr>
//                         <th style={{ width: '40%' }}>Name</th>
//                         <th style={{ width: '50%' }}>Description</th>
//                         <th style={{ width: '10%' }}>Options</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {agencies && agencies.map(agency =>
//                         <tr key={agency.id}>
//                             <td>{agency.name}</td>
//                             <td>{agency.description}</td>
//                             <td style={{ whiteSpace: 'nowrap' }}>
//                                 <Link to={`${path}/edit/${agency.id}`} className="btn btn-sm btn-primary mr-2"> Edit </Link>
//                                 <button onClick={() => deleteAgency(agency.id)} className="btn btn-sm btn-danger mr-2"> Delete
//                                 </button>
//                             </td>
//                         </tr>
//                     )}
//                     {!agencies &&
//                         <tr>
//                             <td colSpan="4" className="text-center">
//                                 <div className="spinner-border spinner-border-lg align-center"></div>
//                             </td>
//                         </tr>
//                     }
//                     {agencies && !agencies.length &&
//                         <tr>
//                             <td colSpan="4" className="text-center">
//                                 <div className="p-2">No Users To Display</div>
//                             </td>
//                         </tr>
//                     }
//                 </tbody>
//             </table>
//         </div>
//     );
